module.exports = __webpack_public_path__ + "static/img/team_title2.499b83fa.png";